import React, { useState, useEffect } from 'react';
import './lista2.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaWhatsapp, FaTags, FaWeightHanging, FaFish } from 'react-icons/fa';
import { GiCow, GiPig, GiChicken, GiMeat, GiKnifeFork, GiSheep, GiSausage } from 'react-icons/gi';

const ProductosG = () => {
    const [productos, setProductos] = useState([]);
    const [categoria, setCategoria] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
    const [fechaFormateada, setFechaFormateada] = useState('');

    const categoryIcons = {
        'VACUNO': <GiCow />,
        'CERDO': <GiPig />,
        'POLLO': <GiChicken />,
        'PESCADOS': <FaFish />,
        'ELABORADOS': <GiKnifeFork />,
        'BÚFALO': <GiMeat />,
        'CORDERO': <GiSheep />,
        'OFERTAS': <FaTags />,
        'COMBOS': <FaWeightHanging />,
        'ACHURAS': <GiSausage />
    };

    useEffect(() => {
        const fetchProductos = () => {
            const sheetId = process.env.REACT_APP_API_SHEETS;
            const apiKey = process.env.REACT_APP_API_KEY;

            if (!sheetId || !apiKey) {
                console.error("Variables de entorno no definidas");
                return;
            }

            // Agregamos un timestamp para evitar el cacheo del navegador/API
            const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/productos?alt=json&key=${apiKey}&t=${new Date().getTime()}`;

            fetch(url, { cache: 'no-store' })
                .then(response => response.json())
                .then(data => {
                    const rows = data.values;
                    if (!rows) return;

                    const headers = rows[0];
                    const productosData = rows.slice(1).map(row => {
                        let producto = {};
                        row.forEach((cell, index) => {
                            producto[headers[index]] = cell;
                        });
                        return producto;
                    });

                    setProductos(productosData);
                    const uniqueCategories = [...new Set(productosData.map(p => p.categoria.trim().toUpperCase()))];
                    setCategoria(uniqueCategories);

                    // Seleccionar la primera categoría solo si no hay una seleccionada
                    if (uniqueCategories.length > 0) {
                        setCategoriaSeleccionada(prev => prev || uniqueCategories[0]);
                    }

                    const fechaActual = new Date();
                    setFechaFormateada(fechaActual.toLocaleDateString('es-AR'));
                })
                .catch(error => console.error('Error al cargar los productos:', error));
        };

        fetchProductos();

        // Refrescar cuando la ventana vuelve a tener foco (el usuario regresa a la pestaña)
        const handleFocus = () => fetchProductos();
        window.addEventListener('focus', handleFocus);

        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    const handleClick = (catId) => {
        const element = document.getElementById(catId);
        if (element) {
            // El desplazamiento ahora lo maneja mejor scrollIntoView con scroll-margin-top en CSS
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Intersection Observer para marcar la categoría activa al scrollear
    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '-180px 0px -70% 0px', // Ajustado para el nuevo tamaño del sticky header
            threshold: 0
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setCategoriaSeleccionada(entry.target.id);
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        categoria.forEach(cat => {
            const element = document.getElementById(cat);
            if (element) observer.observe(element);
        });

        return () => observer.disconnect();
    }, [categoria]);

    const getProductosPorCategoria = (cat) => {
        return productos.filter(producto =>
            producto.categoria.trim().toUpperCase() === cat && producto.disponibilidad !== "0"
        );
    };

    return (
        <div className="lista-premium-container">
            {/* Dark Overlay Header */}
            <header className="lista-header">
                <div className="header-content">
                    <h1 className="bebas-font main-title">Estación de Carnes</h1>
                    <p className="script-font subtitle">de Juan Buenaventura</p>
                    <div className="divider-chalk"></div>
                    <h2 className="bebas-font section-name">Lista de Precios</h2>
                    <div className="status-badges">
                        <span className="fecha-badge">{fechaFormateada}</span>
                        <p className="stock-warning bebas-font">STOCK LIMITADO: COMBOS Y OFERTAS HASTA AGOTAR 500KG</p>
                    </div>
                </div>
            </header>

            <div className="container main-content-lista">
                {/* Categorías Ancladas arriba */}
                <div className="categories-sticky-wrapper">
                    <div className="categories-grid-premium">
                        {categoria.map(cat => (
                            <div
                                className={`category-card-mini ${categoriaSeleccionada === cat ? 'active' : ''}`}
                                key={cat}
                                onClick={() => handleClick(cat)}
                            >
                                <div className="cat-icon-wrapper">
                                    {categoryIcons[cat] || <GiMeat />}
                                </div>
                                <h3 className="bebas-font">{cat}</h3>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Secciones de Productos por Categoría */}
                <div className="all-products-sections mt-5">
                    {categoria.map(cat => {
                        const filteredProds = getProductosPorCategoria(cat);
                        if (filteredProds.length === 0) return null;

                        return (
                            <div key={cat} id={cat} className="category-section animate-fadeIn mb-5">
                                <div className="view-header justify-content-center">
                                    <h2 className="bebas-font active-cat-title text-center">{cat}</h2>
                                </div>

                                <div className="chalk-menu-container">
                                    <ul className="menu-list-chalk">
                                        {filteredProds.map((producto, idx) => (
                                            <li key={`${cat}-${idx}`} className="menu-item-chalk">
                                                <div className="item-details">
                                                    <span className="item-name">{producto.nombre.toUpperCase()}</span>
                                                    <div className="dots-chalk"></div>
                                                    <span className="item-price">$ {producto.precio}</span>
                                                </div>
                                                {producto.descripcion && (
                                                    <p className="item-desc">{producto.descripcion}</p>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Floating WhatsApp */}
            <a
                href="https://wa.me/5493764292187"
                className="wpp-float-premium"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FaWhatsapp />
                <span className="wpp-text bebas-font">¡Consultas por WhatsApp!</span>
            </a>

            <footer className="lista-footer">
                <p className="bebas-font">ESTACIÓN DE CARNES • POSADAS, MISIONES • ARGENTINA</p>
            </footer>
        </div>
    );
};

export default ProductosG;
